import { jsx as _jsx } from "react/jsx-runtime";
import InputAdornment from "@mui/material/InputAdornment";
import { HXIconButton } from "./HXButton";
import { ClearTextFieldIcon, SearchTextField, SearchTextFieldIcon } from "./HXDesktopSearchTextField.styles";
export const HXDesktopSearchTextField = (props) => {
    const { searchText, updateSearchText, onEnterPressed, placeholder, stretch, errorText, grow } = props;
    return (_jsx(SearchTextField, { error: !!errorText, helperText: errorText, stretch: stretch, grow: grow, value: searchText, onChange: (e) => updateSearchText(e.target.value), onKeyUp: (e) => {
            if (onEnterPressed && e.code.toLowerCase() === "enter")
                onEnterPressed();
        }, InputProps: {
            startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(SearchTextFieldIcon, {}) })),
            endAdornment: props.clearButton && searchText ? (_jsx(InputAdornment, { position: "end", children: _jsx(HXIconButton, { onClick: () => updateSearchText(""), children: _jsx(ClearTextFieldIcon, {}) }) })) : undefined,
        }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Search by name, project ID, or keywords" }));
};
